module.exports = __webpack_public_path__ + "static/media/logo_and_title.34f374c0.svg";